/**
 * Módulos que se pueden apagar sin borrar su código.
 *
 * VPS_FILE_CLEANUP_ENABLED — Borrado de archivos desde el panel VPS.
 *   Desactivado el 2026-10-01 y reactivado el 2026-10-04 (doc 0431, A-05): ya no
 *   pasa por shell y no puede borrar fuera de public/.
 *   Su par en el backend es VPS_FILE_CLEANUP_ENABLED del .env (encendido salvo "false").
 *
 * SELF_UPDATE_ENABLED — Botón «Actualizar sistema» de la barra superior (superadmin).
 *   Apagado el 2026-10-25 por decisión del propietario: cada servidor necesitaba el token de
 *   GitHub, y la actualización a veces exige pasos extra que desde el panel la dejaban rota.
 *   Los servidores se actualizan con deploy-vps.sh (PM2) o watoolx.sh update (Docker); la idea
 *   que lo sustituirá es un MVP de actualización centralizada desde la plataforma.
 */
export const VPS_FILE_CLEANUP_ENABLED = true;

export const SELF_UPDATE_ENABLED = false;

export const VPS_FILE_CLEANUP_OFF_MSG =
  "Borrado de archivos desactivado temporalmente por seguridad (doc 0431)";
